import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import icon1 from "images/icon1.svg";
import icon2 from "images/icon2.svg";
import icon3 from "images/icon3.svg";
import icon4 from "images/icon4.svg";
import TabCardGrid2 from "./cards/TabCardGrid2";
import { useState, useEffect } from 'react';
import Light from "./headers/light";
import LightAdmin from "./headers/lightAdmin";
import CatalogueDownload from "./CatalogueDownload";
import { useTranslation } from 'react-i18next';
import WelcomeSection from "./hero/WelcomeSection";
import BioCosmetics from "./BioCosmetics";
import Testimonials from "./Testimonials";
import Footerr from "./footers/Footer";
import { Link } from "react-router-dom"; // 👈 Importation de Link pour la navigation propre

// Transformation du bouton en composant Link pour une compatibilité mobile maximale
const PrimaryButton = tw(Link)`font-bold px-8 lg:px-10 py-3 rounded bg-[#4e7662] text-gray-100 hocus:bg-[#4e7662] focus:shadow-outline focus:outline-none transition duration-300 inline-block text-center`;

export default () => {
    const { t } = useTranslation();
    const [role, setRole] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const userRole = localStorage.getItem('role');
        setRole(userRole); 
    }, []);

    const token = localStorage.getItem('authToken');
    const [products, setProducts] = useState([]);
    const { i18n } = useTranslation();

    useEffect(() => {
        const cached = localStorage.getItem(`products_${i18n.language}`);
        if (cached) {
            setProducts(JSON.parse(cached));
            setLoading(false);
        }

        const fetchProducts = async () => {
            try {
                const response = await fetch(`https://rehabwmg.online/api/products?lang=${i18n.language}`);
                const data = await response.json();
                if (Array.isArray(data)) {
                    setProducts(data);
                    localStorage.setItem(`products_${i18n.language}`, JSON.stringify(data));
                }
            } catch (error) {
                console.error("Error fetching:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [i18n.language]);

    const meilleursVentes = [...products].sort(() => Math.random() - 0.5).slice(0, 4);
    
    const cosmetiques = products
        .filter(p => [111, 92, 90, 74].includes(Number(p.ProductID)))
        .sort((a, b) => [111, 17, 105, 74].indexOf(Number(a.ProductID)) - [111, 17, 105, 74].indexOf(Number(b.ProductID)));
    
    const complements = products
        .filter(p => [60, 13, 7, 4].includes(Number(p.ProductID)))
        .sort((a, b) => [60, 13, 7, 4].indexOf(Number(a.ProductID)) - [60, 13, 7, 4].indexOf(Number(b.ProductID)));
    
    const packs = products
        .filter(p => [179, 176, 172, 165].includes(Number(p.ProductID)))
        .sort((a, b) => [179, 176, 172, 165].indexOf(Number(a.ProductID)) - [179, 176, 172, 165].indexOf(Number(b.ProductID)));
    
    const shampoings = products.filter(p => p.Category === "Shampoing").slice(0, 4);

    return (
        <AnimationRevealPage>
            {role === 'supplier' ? <Light /> : role === 'admin' ? <LightAdmin /> : <Light />}
            <Hero primaryButtonStyles="bg-red-500 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg" />
            <br/>
            <WelcomeSection />
            
            {loading ? (
                <p style={{ textAlign: "center" }}>{t('Produit_en_cours_de_téléchargement')}</p>
            ) : (
                <TabCardGrid2 heading={t('Nos_meilleures_ventes')} products={meilleursVentes} />
            )}
            
            <div style={{ display: "flex", justifyContent: "center" }}>
                {/* Remplacement de href par to */}
                <PrimaryButton to="/Boutique" style={{ backgroundColor: "#4e7662" }}>
                    {t('Voir_plus')}
                </PrimaryButton>
            </div>
            
            <wbr />
            <BioCosmetics/>
            <TabCardGrid2 heading={t('Nos_Cosmetiques')} products={cosmetiques} />
            
            <div style={{ display: "flex", justifyContent: "center" }}>
                <PrimaryButton to="/Cosmetique" style={{ backgroundColor: "#4e7662" }}>
                    {t('Voir_plus')}
                </PrimaryButton>
            </div>

            <Testimonials/>
            <wbr />
            <TabCardGrid2 heading={t('Nos_Complements')} products={complements} />
            
            <div style={{ display: "flex", justifyContent: "center" }}>
                <PrimaryButton to="/Complements" style={{ backgroundColor: "#4e7662" }}>
                    {t('Voir_plus')}
                </PrimaryButton>
            </div>
            
            <wbr />
            <CatalogueDownload />
            <TabCardGrid2 heading={t('Nos_Packs')} products={packs} />
            
            <div style={{ display: "flex", justifyContent: "center" }}>
                <PrimaryButton to="/Packs" style={{ backgroundColor: "#4e7662" }}>
                    {t('Voir_plus')}
                </PrimaryButton>
            </div>
            
            <wbr />
            <TabCardGrid2 heading={t('Nos_Shampoings')} products={shampoings} />
            
            <div style={{ display: "flex", justifyContent: "center" }}>
                <PrimaryButton to="/Shampoing-1l" style={{ backgroundColor: "#4e7662" }}>
                    {t('Voir_plus')}
                </PrimaryButton>
            </div>

            <Features
                heading={<>{t('Nos_promesses')}</>}
                cards={[
                    { imageSrc: icon4, title: t('features.freeShipping.title'), description: t('features.freeShipping.description'), url: "" },
                    { imageSrc: icon2, title: t('features.support.title'), description: t('features.support.description'), url: "" },
                    { imageSrc: icon1, title: t('features.payment.title'), description: t('features.payment.description'), url: "" }
                ]}
                imageContainerCss={tw`p-2!`}
                imageCss={tw`w-20! h-20!`}
            />

            <Footerr />
        </AnimationRevealPage>
    );
}